import type { BaseUsecase } from '@usecases/base-usecase';

export type MuteAgentRequest = boolean;

export interface MuteAgentEventPublisher {
  publish(onMute: boolean): Promise<void>;
}

export interface MuteAgentCallUsecase
  extends BaseUsecase<MuteAgentRequest, void> {
  run(call: MuteAgentRequest): Promise<void>;
}

export class MuteAgent implements MuteAgentCallUsecase {
  constructor(private publisher: MuteAgentEventPublisher) {}

  async run(req: MuteAgentRequest): Promise<void> {
    this.publisher.publish(req);
  }
}
